import { AxiosRequestConfig } from 'axios';
import HTTP from 'libs/HTTP';

// 大模型状态
export enum MODAL_STATUS {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}
// 大模型状态 版本 训练状态
export enum TRAINING_STATUS {
  UN_TRAIN = 'UN_TRAIN', // 未训练
  TRAINING_IN_PROGRESS = 'TRAINING_IN_PROGRESS', // 训练中
  TRAINED = 'TRAINED', // 已训练
  TRAIN_FAIL = 'TRAIN_FAIL' //训练失败
}

// 大模型意图 类型
export enum INTENTION_TYPE {
  REGULAR = 'REGULAR', // 常规意图
  ANCHOR = 'ANCHOR', // 锚点意图
  KNOWLEDGE = 'KNOWLEDGE' // 知识意图
}
export const INTENTION_TYPE_LIST = [
  {
    name: '常规意图',
    value: INTENTION_TYPE.REGULAR
  },
  {
    name: '锚点意图',
    value: INTENTION_TYPE.ANCHOR
  }
  // {
  //   name: '知识意图',
  //   value: INTENTION_TYPE.KNOWLEDGE
  // }
];
export enum EXTRA_CONFIG_TYPE {
  RELATIONSHIP = 'RELATIONSHIP', // 人物关系
  COMMENT_TEMPLATE = 'COMMENT_TEMPLATE', // 评语模版
  TOXICITY_PROHIBITION = 'TOXICITY_PROHIBITION', // 毒害违禁判定
  CONFIG_PARAM = 'CONFIG_PARAM', // 参数配置
  PROMPT_INJECT = 'PROMPT_INJECT', // prompt注入
  OTHER_CONFIG = 'OTHER_CONFIG' // 其他配置
}
class ModalService extends HTTP {
  config: AxiosRequestConfig = {
    baseURL: this.config.baseURL + '/chatbot-server/api'
  };
  // 大模型列表接口
  getList(data: {
    pageNo: number | string;
    pageSize: number | string;
    name?: string;
  }) {
    return this.get('/llm/pageQuery', data);
  }
  addModal(data: {
    background?: string;
    botDesc?: string;
    description?: string;
    name?: string;
    userDesc: string;
  }) {
    return this.post('/llm/create', data);
  }

  editModal(data: any) {
    return this.post(`/llm/update`, data);
  }
  deleteModal(id: string) {
    return this.delete(`/llm/delete/${id}`);
  }
  copyModal(id: string) {
    return this.post(`/llm/copy/${id}`);
  }
  getModalDetail(id: string) {
    return this.get(`/llm/detail/${id}`);
  }
  changeModalStatus(data: { id: string; status: MODAL_STATUS }) {
    return this.post(`/llm/updateStatus`, data);
  }
  // 排序
  sort(data: { sortList: { id: string; sort: number } }) {
    return this.post(`/llm/sort`, data);
  }
  // 调试大模型创建访谈连接
  modalTestconnect(data: { moduleId: string; uid: string; versionId: string }) {
    return this.post(`/llm/connect`, data);
  }
  // 大模型算法训练
  algorithmTrainModal(modalId: string) {
    return this.get(`/llm/algorithmTrain/${modalId}`);
  }
  // 查询大模型算法训练
  algorithmTrainModalStatus(modalId: string) {
    return this.get(`/llm/queryAlgorithmTrainStatus/${modalId}`);
  }
  // 大模型版本列表接口
  getModalVersionList(data: {
    pageNo: number | string;
    pageSize: number | string;
    llmId: string;
  }) {
    return this.get('/llm/version/pageQuery', data);
  }
  addModalVersion(data: any) {
    return this.post('/llm/version/create', data);
  }
  deleteModalVersion(version_id: string) {
    return this.delete(`/llm/version/delete/${version_id}`);
  }
  // 大模型版本算法训练
  algorithmTrain(version_id: string) {
    return this.get(`/llm/version/algorithmTrain/${version_id}`);
  }
  // 终止训练
  stopAlgorithmTrain(version_id: string) {
    return this.get(`/llm/version/stop/train/${version_id}`);
  }
  // 查询训练状态
  algorithmTrainStatus(version_id: string) {
    return this.get(`/llm/version/queryAlgorithmTrainStatus/${version_id}`);
  }
  // 设置主版本
  serMoalMasterVersion(data: { id: string; llmId: string; master: 'Y' | 'N' }) {
    return this.post('/llm/version/setLlmVersionMaster', data);
  }
  // 调试创建访谈连接
  versionConnect(version_id: string) {
    return this.post(`/llm/version/connect/${version_id}`);
  }
  // 大模型配置-模块接口
  addConfigModule(data: any) {
    return this.post('/llm/module/create', data);
  }
  editConfigModule(data: any) {
    return this.post('/llm/module/update', data);
  }
  deleteConfigModule(module_id: string) {
    return this.delete(`/llm/module/delete/${module_id}`);
  }
  updateModuleDissentSwitch(data: { dissentSwitch: number; id: string }) {
    return this.post('/llm/module/updateModuleDissentSwitch', data);
  }
  getConfigModuleDetail(module_id: string) {
    return this.get(`/llm/module/detail/${module_id}`);
  }
  getConfigModuleList(data: {
    pageNo: number | string;
    pageSize: number | string;
    versionId: string;
    llmId: string;
  }) {
    return this.post('/llm/module/pageQuery', data);
  }
  // 排序
  moduleSort(data: { sortList: any[]; versionId: string }) {
    return this.post('/llm/module/sort', data);
  }
  // 大模型配置-模块-意图接口
  addConfigModuleIntention(data: any) {
    return this.post(`/llm/intent/create`, data);
  }
  editConfigModuleIntention(data: any) {
    return this.post(`/llm/intent/update`, data);
  }
  deleteConfigModuleIntention(intention_id: string) {
    return this.delete(`/llm/intent/delete/${intention_id}`);
  }
  // 修改意图 MUST开关
  updateIntentMustSwitch(data: { id: string; mustSwitch: number }) {
    return this.post(`/llm/intent/updateIntentMustSwitch`, data);
  }
  getConfigModuleIntentionDetail(intention_id: string) {
    return this.get(`/llm/intent/detail/${intention_id}`);
  }
  getConfigModuleIntentionList(data: {
    pageNo: number | string;
    pageSize: number | string;
    moduleId?: string;
    name?: string;
    type?: INTENTION_TYPE;
  }) {
    return this.post('/llm/intent/pageQuery', data);
  }
  // 查询不在当前模块下意图信息
  getOtherConfigModuleIntentionList(data: { id?: string; name?: string }) {
    return this.queryGet(`/llm/intent/queryIntentNotModule`, data);
  }
  // 查询 某个版本下面的 意图
  getVersionIntentionList(versionId: string) {
    return this.queryGet(`/llm/intent/queryModuleIntent/${versionId}`);
  }
  // 大模型意图配置-其他接口
  addExtraConfig(data: {
    extraConfig: any;
    llmId: string;
    versionId: string;
    type: EXTRA_CONFIG_TYPE;
  }) {
    return this.post(`/llm/extra/config/create`, data);
  }
  eidtExtraConfig(data: { extraConfig: any; id: string }) {
    return this.post(`/llm/extra/config/update`, data);
  }
  getExtraConfig(data: {
    llmId: string;
    versionId: string;
    type: EXTRA_CONFIG_TYPE;
  }) {
    return this.post(`/llm/extra/config/queryExtraConfigByType`, data);
  }
  // 意图转移
  intentTransfer(data: { intentId: string; targetModuleId: string }) {
    return this.post(`/llm/intent/transfer`, data);
  }
  // 配置一览表
  createDownload(versionId: string) {
    return this.get(`/llm/module/async/download`, { versionId: versionId });
  }
  // 查询任务状态
  getDownloadTask(taskId: string) {
    return this.get(`/llm/module/async/download/result`, { taskId: taskId });
  }
  // 下载 Execl
  downExcel(taskId: string) {
    return this.post(`/llm/module/async/download/excel/?taskId=${taskId}`);
  }
}

export default new ModalService();
